/* eslint-disable max-len */
import routersManager from "@/managers/routers.manager";
import { defineComponent } from "vue";
import { QuizType } from "../quiz/QuizComponent";
import store from "@/store";
import studioService from "@/services/studio.interface";
enum Actions {
    SHOW_LOCATION_DATA = "showLocationData",
    GET_ALL_HAS_3D = "getAllScene3D", 
    RETURN_ALL_HAS_3D = "returnAllScenes3D",
    LOADED = "loaded"
}
export default defineComponent({
    name: "MapComponent",
    data() {
        return {
            url: null,
            route: null,
            messageListener: (messageEvent) => this.onMessageReceived(messageEvent),
            showData: false,
            currentLocation: null,
            index: 0,
            loading: true,
            imagen: "",
            showQuiz: false,
            QuizType: QuizType
        };
    },
    computed: {
        computedStyle(): Record<string, string> {
            return {
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                width: '100%',
                height: '100%',
                zIndex: '999',
                display: this.showData ? 'none' : 'block',
                border: 'none'
            };
        }
    },
    async mounted() {
        this.route = await routersManager.getRoute((this.$route.params.name as string).replace(/_/g, ' '));
        this.url = this.route.url;
    },
    async created() {
        window.addEventListener("message", this.messageListener);
    },
    beforeUnmount() {
        window.removeEventListener("message", this.messageListener);
    },
    methods: {
        async onMessageReceived(msg) {
            if (msg && msg.data) {
                try {
                    const gameMessage = typeof msg.data == 'string' ?  JSON.parse(msg.data) : msg.data;
                    if (gameMessage.oxAction == Actions.SHOW_LOCATION_DATA) {
                        this.index = this.route.locations.findIndex(l => l.oid == gameMessage.oid);
                        this.currentLocation = this.route.locations[this.index];
                        this.showData = true;
                        if (!this.currentLocation.ar) {
                            studioService.addNewView(this.currentLocation.oid, this.route.token);
                        }
                    } else if(gameMessage.oxAction == Actions.GET_ALL_HAS_3D) {
                        const data = this.route.locations.map(l => {
                            return {
                                oid: l.oid,
                                has3D: l.ar
                            }
                        });
                        const msg = {
                            oxAction: Actions.RETURN_ALL_HAS_3D,
                            data: data
                        }
                        this.sendToModule(msg)
                    } else if(gameMessage.oxAction == Actions.LOADED) {
                        this.loading = false;
                    }
                } catch (error) {
                    console.debug(`Unknown message`, msg.data, error);
                }
            }
        },
        sendToModule(msg): void {
            msg["origin"] = "RutasPorMadrid";
            (this.$refs.onirixIframe as HTMLIFrameElement).contentWindow.postMessage(JSON.stringify(msg), "*");
        },
        scrollToTop(): void {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        close(): void {
            this.showData = false;
            if (this.currentLocation.quiz && !store.getters.locations.find(l => l == this.currentLocation.name)) {
                this.showQuiz = true;
            }
        },
        hideQuiz(event: boolean): void {
            this.showQuiz = false;
            store.commit("addLocation", this.currentLocation.name);
            if (event) {
                this.$router.push({ name: "home" });
            }
        }
    }
});
